import React from 'react';
import CSS from './techInfo.module.css';

export function TechnicalInformation ({ product }) {

    const technicalInfo = product.data.attributes.product_information;

    if (technicalInfo && technicalInfo.length > 0) {
        return (
            <div className={CSS.container}>
            {technicalInfo.map((info, index) => (
                <div className={CSS.rad} key={index}>
                <div className={CSS.statisk}>
                    {info.infoText}
                </div>
                <div className={CSS.dynamisk}>
                    {info.infoValue}
                </div>
                </div>
            ))}
            </div>
        );
        } else {
        return (
            <div className={CSS.container}>
            <p>Ingen teknisk informasjon tilgjengelig.</p>
            </div>
        );
    }
}

export default TechnicalInformation;